import React, { useEffect, useState } from "react";
import "./generic.css";
import i18n from "../../i18n/config";

interface ButtonProps {
    lang: string,
    src: any,

    openOtherLang: boolean
    setOpenOtherLang: any,
    tooltipText: string,
}

const FlagButton: React.FC<ButtonProps> = (props) => {
    const [tooltip, setTooltip] = useState(false);
    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        props.setOpenOtherLang(false);
        setTooltip(false);
    }
    return (
        <button 
        onMouseEnter={() => setTooltip(true)}
        onMouseLeave={() => setTooltip(false)}
        onClick={() => changeLanguage(props.lang)}
        className="flag-button">
            <img className="flags-icon" src={props.src} alt="" />
            {tooltip 
            ?
            <p className="flag-tooltip">{props.tooltipText}</p>
            :
            <></>}
        </button>
    );
  };
  export default FlagButton;